tag links-section
	<self.links-section>
		<div.slot>
			<a.btn.btn-menu route-to="/$"> "Home"
			<a.btn.btn-menu route-to="/posts$"> "Posts"
			<a.btn.btn-menu route-to="/staff$"> "Staff"
			<a.btn.btn-menu href="https://www.elexiogiving.com/app/giving/gracesa" target="_blank"> "Giving"
			# <a.btn.btn-menu route-to="/forms$"> "Forms"
			# <a.btn.btn-menu route-to="/partners"> "Ministry Partners"
			# <a.btn.btn-menu route-to="/youth"> "Youth"
			# <a.btn.btn-menu route-to="/app"> "App"
			# <a.btn.btn-menu route-to="/who-we-are$"> "About"
			# <a.btn.btn-menu route-to="/history$"> "History"

css .links-section
	d:flex
	jc:center

	.slot
		d:flex
		jc:space-around
		flw:wrap

		.btn.btn-menu
			mx:.5em
			mx@lt-md:0
			px@lt-md:.5em

		.btn.active
			bdb: 5px solid warmer7